// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fontOther {\n  color: #2c3852;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 16px;\n}", ""]);
// Exports
module.exports = exports;
